<template>
  <section class="page" :class="{ disabled: disablePage }">
    <div v-if="loading" class="saving">
      <img style="width: 30px" src="img/Gif_autosave.gif" />
      <span class="ml-2 text-gray-600">Saving...</span>
    </div>

    <div class="templateName">
      <CCol v-if="loagingPage" sm="12" class="d-flex justify-content-center align-items-center mb-3" style="height: 300px">
        <CSpinner color="custom-color" style="width: 4rem; height: 4rem" />
      </CCol>
      <CForm v-else @submit.prevent="namingTemplate">
        <CInput
          style="width: 500px"
          :placeholder="$t('templates.grapes.template-name')"
          addLabelClasses="text-gray m-0 mr-3"
          :label="$t('templates.grapes.template-name')"
          class="d-flex inputTemplateName"
          ref="templateName"
          v-model="$v.templateName.$model"
          :isValid="checkIfValid('templateName')"
          :invalidFeedback="$t('general.inputFeedback.required-and-minLength-3')"
          @input="namingTemplateInInputEvent"
        >
          <template #append-content>
            <span class="inputTemplateName__append z4" v-if="!hasTemplateId">
              <CButton @click="namingTemplate" :disabled="$v.$invalid" title="save">
                <CIcon class="text-dark" size="custom-size" :height="20" viewBox="0 0 32 32" name="saveDisk" color="transparent" />
              </CButton>
            </span>
          </template>
        </CInput>
      </CForm>
    </div>

    <div class="page-messages">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
    </div>

    <div :class="{ disabled: disablePage }" id="gjs-nl" style="height: 100vh; overflow: hidden; width: 100%" class="gjs-editor-cont"></div>
  </section>
</template>

<script>
import grapesjs from 'grapesjs'
import ClipboardJS from 'clipboard'
import grapesJSMJML from 'grapesjs-mjml'

import en from 'grapesjs/locale/en'
import pt from 'grapesjs/locale/pt'

import { mapGetters } from 'vuex'
import { storageManagerConfig } from '../configGrapes/storage-manager.config'
import loadPanels from '../configGrapes/panels-config'
import loadCommands from '../configGrapes/commands-config'
import loadblockManager from '../configGrapes/blockManager-config'
import componentTypes from '../configGrapes/componentTypes'

import { validationMixin } from 'vuelidate'
import { minLength, required } from 'vuelidate/lib/validators'
import MenssageAlert from '@/components/MenssageAlert'
import services from '@/services.js'
const CUSTOM_GROUP = 'CUSTOM'
import { v4 as uuidv4 } from 'uuid'
import Compressor from 'compressorjs'

export default {
  name: 'grapesEditor',
  components: {
    MenssageAlert,
  },
  data() {
    return {
      messages: [],
      loading: false,
      loagingPage: true,
      editor: null,
      assetManager: null,
      blockManager: null,
      domComponents: null,
      panels: null,
      commands: null,
      i18n: null,
      templateName: null,
      nameTimeout: null,
      autoLoad: false,
      urlStore: null,
      urlLoad: null,
      customTypes: [],
      personalizationTags: null,
      autoSaving: null,
    }
  },

  mixins: [validationMixin],

  validations: {
    templateName: {
      required,
      minLength: minLength(1),
    },
  },

  created() {
    this.getSchema()

    if (this.hasTemplateId) {
      this.autoLoad = true
      this.setUrls(this.hasTemplateId)
    }
  },

  mounted() {
    this.loagingPage = Boolean(this.hasTemplateId)
    const $vue = this

    var clipboard = new ClipboardJS('.btn')

    clipboard.on('success', function (e) {
      e.clearSelection()
    })

    this.editor = grapesjs.init({
      fromElement: 1,
      container: '#gjs-nl',
      avoidInlineStyle: false,
      height: '100vh',
      cors: {
        enabled: true,
        origin: this.$configs.VUE_APP_ROOT_API,
      },
      i18n: {
        locale: 'pt', // default locale
        // detectLocale: true, // by default, the editor will detect the language
        // localeFallback: 'en', // default fallback
        messages: { pt },
      },
      storageManager: storageManagerConfig(this.autoLoad, this.urlStore, this.urlLoad),
      plugins: [grapesJSMJML],
      // plugins: [grapesJSMJML, gjsPluginCkeditor],
      pluginsOpts: {
        [grapesJSMJML]: {},
        // [gjsPluginCkeditor]: {
        //   /* ...options */
        //   skin: 'n1theme',
        //   options: loadcheckEditor(this.editor, $vue)
        // }
      },
      assetManager: {
        disableUpload: false,
        uploadFile: this.uploadAsset,
      },
    })

    loadPanels(this.editor, $vue)
    loadCommands(this.editor, $vue)
    loadblockManager(this.editor, $vue, grapesJSMJML)

    //fix erro firefox
    this.editor.on('load', (e) => {
      e.DomComponents.getWrapper().set('style', { height: '100%' })
    })

    this.columnFields()

    this.editor.on('storage:start:load', () => {
      this.loading = true
    })

    this.editor.on('storage:end:load', (resultObject) => {
      this.$nextTick(() => {
        this.templateName = resultObject.templateName
        this.editor.StorageManager.getCurrentStorage().attributes.params = {
          templateName: resultObject.templateName,
        }
      })

      this.loading = false
      this.loagingPage = false
    })

    this.editor.on('storage:start:store', (objectToStore) => {
      this.loading = true
      objectToStore.templateHTML = this.editor.runCommand('mjml-get-code').html
    })

    this.editor.on('storage:end:store', () => {
      this.loading = false
      this.loagingPage = false
    })

    this.removeButtons()

    this.editor.setComponents(`<mjml><mj-head></mj-head><mj-body></mj-body></mjml>`)

    this.setActiveInit()

    this.startAutoSaving()
  },

  destroyed() {
    this.stopAutoSaving()
    this.editor = {}
    this.editor.destroy
  },

  beforeDestroy() {
    this.stopAutoSaving()
    this.editor = {}
    this.editor.destroy
  },

  methods: {
    uploadAsset(e) {
      const files = e.dataTransfer ? e.dataTransfer.files : e.target.files

      const organizationId = this.$route.params.id
      const templateId = this.hasTemplateId
      const assetManager = this.editor.AssetManager
      const messages = this.messages

      files.forEach((file) => {
        new Compressor(file, {
          quality: 0.7,

          // The compression process is asynchronous,
          // which means you have to access the `result` in the `success` hook function.
          success(result) {
            const formData = new FormData()
            result.id = uuidv4()
            formData.append(`file`, result, result.name)
            formData.append(`id`, result.id)

            services
              .uploadImageTemplateGrapes(organizationId, templateId, formData)
              .then((data) => {
                const image = data.data.data

                const assets = []

                assets.push({
                  name: image.fileName,
                  src: image.url,
                  id: image.id,
                })

                assetManager.add(assets)
                assetManager.render()
              })
              .catch((error) => {
                messages.push({
                  status: 'danger',
                  text: error.response.data.message || 'Error',
                })
              })
          },
          error(err) {
            console.log(err.message)
          },
        })
      })
    },

    checkIfValid(fieldName) {
      const field = this.$v[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || null)
    },

    stopAutoSaving() {
      clearInterval(this.autoSaving)
    },

    startAutoSaving() {
      if (!this.$route.params.id) {
        return
      }

      this.autoSaving = setInterval(() => {
        if (this.editor.getDirtyCount()) {
          this.editor.runCommand('autosave-template')
        }
      }, this.$configs.VUE_APP_SECONDS_TO_AUTOSAVE_CAMPAIGN || 5000)
    },

    customLabel(option) {
      return `${option.value}`
    },

    async getSchema() {
      this.messages = []
      try {
        const FIELD_TYPES = await services.fieldtypes(this.$route.params.organizationId)

        const SCHEME = await services.audienceSchema(this.$route.params.organizationId)

        if (SCHEME.data.data.errorCode === 1000) {
          this.customTypes = [...this.handleCustomtypes(FIELD_TYPES)]
          return
        }

        this.customTypes = [...SCHEME.data.data.values, ...this.handleCustomtypes(FIELD_TYPES)]
      } catch (error) {
        if (error.response.data.message == 'AUDIENCE_SCHEMA_NOT_FOUND') return

        this.messages.push({
          status: 'danger',
          text: error.response.data.message || 'Error',
        })
      }
    },

    handleCustomtypes(FIELD_TYPES) {
      let CUSTOMS = FIELD_TYPES.data.data.groups.filter((group) => group.group == CUSTOM_GROUP)

      if (CUSTOMS[0].types.lenght) {
        return CUSTOMS.map((item, index) => {
          return {
            personalizationTag: item.types[index].personalizationTag,
          }
        })
      }

      return []
    },

    setUrls(templateId) {
      let organizationId = this.$route.params.organizationId
      this.urlStore = `${this.$configs.VUE_APP_ROOT_API}template/api/v1.0/email/${organizationId}/${templateId}/grapesjs-payload`
      this.urlLoad = `${this.$configs.VUE_APP_ROOT_API}template/api/v1.0/email/${organizationId}/${templateId}/grapesjs-payload`
    },

    // TODO mudar função para panels-config caso o bloco fique em panels
    columnFields() {
      if (this.personalizationTags) return

      let editPanel = null
      this.editor.Panels.addButton('views', {
        id: 'open-code',
        className: 'fa fa-list',
        attributes: {
          title: this.$t('templates.grapes.title-block-field-types'),
        },
        command: {
          run: () => {
            if (editPanel == null) {
              const editMenuDiv = document.createElement('div')

              editMenuDiv.innerHTML = `
                    <div>
											 <h4  class="gjs-sm-header">${this.$t('templates.grapes.title-block-field-types')}</h4>
                        <p>click to copy</p>
                        ${this.personalizationTags}
                      <div>
                    `
              const panels = this.editor.Panels.getPanel('views-container')

              panels.set('appendContent', editMenuDiv).trigger('change:appendContent')
              editPanel = editMenuDiv
            }
            editPanel.style.display = 'block'
          },
          stop: () => {
            if (editPanel != null) {
              editPanel.style.display = 'none'
            }
          },
        },
      })
    },

    updatedLang(lang) {
      this.editor.I18n.setLocale(lang.split('-')[0] || 'en')
      this.editor.Panels.render()
    },

    savingWhenHasTemplateId() {
      this.editor.StorageManager.getCurrentStorage().attributes.params = {
        templateName: this.templateName,
      }
      this.editor.store(() => {
        this.loagingPage = false
      })
    },

    async createNewTemplate() {
      this.messages = []
      try {
        let formData = new FormData()
        if (this.$route.params.campaignId) {
          formData.append('CampaignId', this.$route.params.campaignId)
        }
        formData.append('Name', this.templateName)
        let organizationId = this.$route.params.organizationId

        const response = await services.sendTemplatesEmail(organizationId, formData)

        if (response.data.success) {
          this.setUrls(response.data.data.emailTemplateId)
        }

        this.saveStorage({
          html: '<mjml><mj-body></mj-body></mjml>',
          components: '',
          assets: '[]',
          css: '',
          styles: '[]',
        })

        let paramsCampaign = this.$route.params.campaignId ? this.$route.params : ''

        this.$router.push({
          name: 'email-builder',
          params: { id: response.data.data.emailTemplateId, ...paramsCampaign },
        })
      } catch (error) {
        this.messages.push({
          status: 'danger',
          text: error.response.data.message || error || 'ERROR',
        })
      }

      this.loagingPage = false
    },

    saveStorage(obj) {
      this.editor.StorageManager.getCurrentStorage().attributes.urlStore = this.urlStore
      this.editor.StorageManager.getCurrentStorage().attributes.urlLoad = this.urlLoad

      this.editor.StorageManager.store(obj)
    },

    namingTemplateInInputEvent() {
      if (this.hasTemplateId) {
        this.namingTemplate()
      }
    },

    namingTemplate() {
      if (this.nameTimeout) clearTimeout(this.nameTimeout)

      if (this.$v.$invalid) {
        return
      }
      this.nameTimeout = setTimeout(() => {
        if (!this.hasTemplateId) {
          this.loagingPage = true
          this.createNewTemplate()
          return
        }

        this.savingWhenHasTemplateId()
      }, 500)
    },

    setActiveInit() {
      setTimeout(() => {
        if (!this.loagingPage) {
          this.editor.Panels.getButton('views', 'open-blocks').set('active', true)
          this.editor.Panels.getButton('options', 'redo').set('className', 'fa fa-redo')
        }
      }, 500)

      // para capiturar os erros
      this.editor.setComponents = (function (originalFct) {
        return function (components) {
          try {
            originalFct(components)
          } catch (ex) {
            throw 'Parse error: ' + ex
          }
        }
      })(this.editor.setComponents)
    },

    removeButtons() {
      const exportTemplate = this.editor.Panels.getButton('options', 'export-template')
      const mjmlImport = this.editor.Panels.getButton('options', 'mjml-import')
      const layer = this.editor.Panels.getButton('views', 'open-layers')
      exportTemplate.collection.remove(exportTemplate)
      mjmlImport.collection.remove(mjmlImport)
      layer.collection.remove(layer)
    },
  },

  computed: {
    ...mapGetters({
      lang: 'getLang',
    }),

    hasTemplateId() {
      return this.$route.params.id
    },

    disablePage() {
      return this.$route.params.id == undefined || this.loagingPage == true
    },
  },

  watch: {
    lang: {
      handler(value) {
        this.updatedLang(value)
      },
    },

    customTypes: {
      handler(value) {
        this.personalizationTags = componentTypes(value)
      },
      deep: true,
    },

    hasTemplateId: {
      handler(newValue) {
        this.setUrls(newValue)
      },
    },

    $route: {
      // caso a pagina perca o id no paramento
      handler(newValue, oldValue) {
        if (oldValue.params.id && newValue.name == 'email-builder') {
          this.$router.push({ name: 'new-template-list', params: oldValue.params })
        }
      },
    },
  },
}
</script>

<style lang="scss">
.page-messages {
  position: absolute;
  bottom: 0;
  z-index: 10;
}

[data-gjs-type='mj-body'] {
  height: 100vh !important;
}

.page {
  .templateName {
    max-width: 700px;
    position: absolute;
    z-index: 10;
    left: 1%;
    top: 10px;

    .inputTemplateName {
      box-shadow: none;
      margin: 0 auto;
      max-width: 300px;
      flex-direction: column;
      display: flex;

      label {
        color: #d1d4da;
      }

      .input-group-append {
        border-bottom: 1px solid #d1d4da;
        position: relative;
        border: none;
        border-bottom: 1px solid #d1d4da;

        .input-group-text {
          padding: 0;
          background: none;
          border: none;
        }
      }

      .form-control {
        border: none;
        background-color: transparent;
        border-bottom: 2px solid var(--gray-base);
        min-width: 300px;
        text-transform: uppercase;
        color: #7f889a;
        font-size: 14px;
        transition: 300ms;
        box-shadow: none;
        height: 25px;
        padding: 0;
        &:hover,
        &:focus {
          box-shadow: none !important;
          border-bottom: 1px solid #d1d4da;

          & + .input-group-append {
            border-bottom: 1px solid #d1d4da;
          }
        }
      }

      .invalid-feedback {
        margin-top: 15px;
      }
    }
  }

  &.disabled {
    .templateName {
      position: fixed;
      top: 15%;
      transform: translateX(-85%);
      left: 50%;

      label {
        color: var(--gray-base);
        margin-bottom: 50px;
        text-align: center;
        font-size: 1.75rem !important;
      }

      .inputTemplateName {
        box-shadow: none;
        margin: 0 auto;
        max-width: 500px;
        flex-direction: column;
        .input-group-append {
          position: relative;
          border: none;
          border-bottom: 1px solid #d1d4da;

          .input-group-text {
            padding: 0;
            background: none;
            border: none;
          }
        }

        .form-control {
          border: none;
          background-color: transparent;
          border-bottom: 1px solid #d1d4da;
          min-width: 300px;
          text-align: center;
          text-transform: uppercase;
          color: #7f889a;
          font-size: 14px;
          transition: 300ms;
          box-shadow: none;
          height: initial;
          &:hover,
          &:focus {
            border-bottom: 2px solid var(--gray-base);
            box-shadow: none !important;

            & + .input-group-append {
              border-bottom: 2px solid var(--gray-base);
            }
          }
        }
      }
    }
  }
}

.saving {
  position: absolute;
  top: 15%;
  left: 5%;
  z-index: 10;
}
</style>
